class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keydown', this.onKeyDown.bind(this));
    this.addEventListener('keyup', this.onKeyUp);
    this.mainDetailsToggle = this.querySelector('details');
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));

    // Add event listener specifically for the header__menu-item
    this.menuItem = this.mainDetailsToggle.querySelector('.header__menu-item');
    this.menuItem.addEventListener('mouseover', this.onHover.bind(this));
    this.menuItem.addEventListener('click', this.onClick.bind(this));

    // Store the previously hovered element
    this.previousHoverElement = null;
  }

  onClick(event) {
    const summary = event.target.closest('summary');
    if (!summary) return;

    const menuUrl = summary.dataset.menuUrl;
    if (!menuUrl) return;

    event.preventDefault();
    window.location.href = menuUrl;
  }

  onKeyDown(event) {
    const summary = event.target.closest('summary');
    if (!summary) return;

    const keyCode = event.code.toUpperCase();

    if (keyCode === 'SPACE') {
      event.preventDefault();
      this.mainDetailsToggle.open ? this.close(false) : this.open(event);
      return;
    }

    if (keyCode === 'ARROWDOWN' || keyCode === 'ARROWRIGHT') {
      event.preventDefault();
      this.open(event);
      this.focusFirstSubmenuItem();
      return;
    }

    if (keyCode === 'ENTER') {
      const menuUrl = summary.dataset.menuUrl;
      if (menuUrl) {
        event.preventDefault();
        window.location.href = menuUrl;
      }
    }
  }

  focusFirstSubmenuItem() {
    const submenuContent = this.mainDetailsToggle.querySelector('.header__submenu-contents');
    if (!submenuContent) return;

    const firstLink = submenuContent.querySelector(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    firstLink?.focus();
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', 'false');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onHover(event) {
    const menuItemTarget = event.target.closest('.header__menu-item');
    if (menuItemTarget === this.previousHoverElement) return;
    this.previousHoverElement = menuItemTarget;

    event.preventDefault();
    this.open(event);
  }

  onMenuClose(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open(event) {
    event.target.closest('nav').querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    });

    this.onMenuCloseEvent =
      this.onMenuCloseEvent || this.onMenuClose.bind(this);
    this.mainDetailsToggle.setAttribute('open', true);
    this.menuItem.setAttribute('aria-expanded', 'true');
    document.body.addEventListener('click', this.onMenuCloseEvent);
    document.body.addEventListener('mouseover', this.onMenuCloseEvent);

    trapFocus(
      this.mainDetailsToggle.querySelector('.header__submenu-contents')
    );
  }

  close(focusToggle = true) {
    this.previousHoverElement = null;
    removeTrapFocus(focusToggle ? this.mainDetailsToggle : null);
    this.mainDetailsToggle.removeAttribute('open');
    this.menuItem.setAttribute('aria-expanded', 'false');
    document.body.removeEventListener('click', this.onMenuCloseEvent);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
